import { render, staticRenderFns } from "./GoodsAttention.vue?vue&type=template&id=bbaa8448&scoped=true"
import script from "./GoodsAttention.vue?vue&type=script&lang=js"
export * from "./GoodsAttention.vue?vue&type=script&lang=js"
import style0 from "./GoodsAttention.vue?vue&type=style&index=0&id=bbaa8448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaa8448",
  null
  
)

export default component.exports